module.exports = __webpack_public_path__ + "img/logo-unicampo-small.69e0771e.png";